import taskHandler from "./handlers/task";
import toolbarHandler from "./handlers/toolbar";
export default function (store, { id, action, type, params }) {
    switch (type) {
        case "task":
            taskHandler(store, id, action);
            return;
        case "toolbar":
            toolbarHandler(store, {
                id,
                action,
                locale: params.locale,
            });
            return;
    }
}
//# sourceMappingURL=click.js.map